/**
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export const KV = {
  URL: 'url',
  DownloadSize: 'downloadSize',
  FileURL: 'fileURL',
  FileSize: 'fileSize'
}

/** 清晰度列表优先级顺序 */
export const PropertyPriority = {
  'same': 1,
  '1080p': 2,
  '720p': 3,
  '480p': 4,
  '360p': 5,
  'a': 6
}
